import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"
import { ColorCodeService } from "../../services/color-code.service"
import { EduComponent } from "../../utils/eduComponent"
import { Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"

@Component({
    selector: "app-topics",
    templateUrl: "./topics.component.html",
    styleUrls: ["./topics.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class TopicsComponent extends EduComponent implements OnInit, OnDestroy {
    activeNode: CHNode
    activeTopic: CHNode
    activeSubject: CHNode
    colorCode: string = "#fff"
    private destroyed$ = new Subject()

    constructor(
        private browsingService: BrowsingService,
        private colorCodeService: ColorCodeService
    ) {
        super()
    }

    ngOnInit() {
        this.colorCode = this.colorCodeService.getPrimaryColor()
        this.subscribeToActiveNodeChanges()
    }

    public subscribeToActiveNodeChanges(): void {
        this.browsingService.activeNodeChanged
            .pipe(
                takeUntil(this.destroyed$),
                tap((node: CHNode) => this.handleNewNode(node))
            )
            .subscribe()
    }

    public handleNewNode(node: CHNode): void {
        this.activeNode = node
        this.activeTopic = node.getTopic()
        this.activeSubject = node.getSubject()
        this.colorCode = this.colorCodeService.getColorForNode(node)
    }

    /**
     * Add '+' sign if item is expandable
     * Add '-' sign if item is expanded
     * @param topic
     */
    getExpandableIcon(topic: CHNode): string {
        // if topic is selected show minus
        if (topic === this.activeTopic) return "fa-minus"

        // if topic has any children selected show minus
        let isChildSelected = topic.children.some((child) => child === this.activeNode)
        if (isChildSelected) return "fa-minus"

        // if topic has children show plus
        if (topic.children.length) return "fa-plus"
        return ""
    }

    ngOnDestroy() {
        super.ngOnDestroy()

        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
